module.exports = __webpack_public_path__ + "static/img/a057.40faf01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a057.jpg
// module id = 2wsy
// module chunks = 0